import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const CustomerPage = lazy(() => import('src/pages/dashboard/customer/all'));
const SupportPage = lazy(() => import('src/pages/dashboard/customer/support'));
const CreditPage = lazy(() => import('src/pages/dashboard/customer/credit'));
const CreditApprovalPage = lazy(() => import('src/pages/dashboard/customer/credit_approval'));
const StaffPage = lazy(() => import('src/pages/dashboard/staff/all'));

const ProductInsightsPage = lazy(() => import('src/pages/dashboard/item/product-insights'));
const ProductsPage = lazy(() => import('src/pages/dashboard/item/product'));
const CategoriesPage = lazy(() => import('src/pages/dashboard/item/categories'));
const ProductGroupPage = lazy(() => import('src/pages/dashboard/item/group'));
const ExpiresPage = lazy(() => import('src/pages/dashboard/item/expires'));
const DamagesPage = lazy(() => import('src/pages/dashboard/item/damages'));
const PricingPage = lazy(() => import('src/pages/dashboard/item/pricing'));
const BulkPricingPage = lazy(() => import('src/pages/dashboard/item/bulk-pricing'));
const ComboPage = lazy(() => import('src/pages/dashboard/item/combo'));
const PackagePage = lazy(() => import('src/pages/dashboard/item/package'));

const SalesInsightsPage = lazy(() => import('src/pages/dashboard/order/sales-insights'));
const OrdersPage = lazy(() => import('src/pages/dashboard/order/all'));
const ReviewsPage = lazy(() => import('src/pages/dashboard/order/reviews'));

const DeliveryInsightsPage = lazy(() => import('src/pages/dashboard/delivery/delivery-insights'));
const DeliveryPersonPage = lazy(() => import('src/pages/dashboard/delivery/delivery-person'));
const ReturnsPage = lazy(() => import('src/pages/dashboard/delivery/returns'));
const ReturnsRefundPage = lazy(() => import('src/pages/dashboard/delivery/returns-refund'));
const ZonesPage = lazy(() => import('src/pages/dashboard/delivery/zone'));
const CitiesPage = lazy(() => import('src/pages/dashboard/delivery/city'));
const UtilitiesPage = lazy(() => import('src/pages/dashboard/delivery/delivery-utility'));

const BannerConfigPage = lazy(() => import('src/pages/dashboard/configurations/banner-config'));
const FeaturedProductConfigPage = lazy(() => import('src/pages/dashboard/configurations/feature-product-config'));

const PageProfileSecurity = lazy(() => import('src/pages/dashboard/profile/security'));
// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'user',
        children: [
          { element: <CustomerPage />, index: true },
          { path: 'customer', element: <CustomerPage /> },
          { path: 'support', element: <SupportPage /> },
          { path: 'credit', element: <CreditPage /> },
          { path: 'credit_approval', element: <CreditApprovalPage /> },
          { path: 'staff', element: <StaffPage /> },
        ],
      },
      {
        path: 'item',
        children: [
          { element: <ProductInsightsPage />, index: true },
          { path: 'insights', element: <ProductInsightsPage /> },
          { path: 'product', element: <ProductsPage /> },
          { path: 'category', element: <CategoriesPage /> },
          { path: 'product_group', element: <ProductGroupPage /> },
          { path: 'expires', element: <ExpiresPage /> },
          { path: 'damages', element: <DamagesPage /> },
          { path: 'pricing', element: <PricingPage /> },
          { path: 'bulk_pricing', element: <BulkPricingPage /> },
          { path: 'combo', element: <ComboPage /> },
          { path: 'package', element: <PackagePage /> }
        ],
      },
      {
        path: 'order',
        children: [
          { element: <SalesInsightsPage />, index: true },
          { path: 'insights', element: <SalesInsightsPage /> },
          { path: 'all', element: <OrdersPage /> },
          { path: 'review', element: <ReviewsPage /> }
        ]
      },
      {
        path: 'delivery',
        children: [
          { element: <DeliveryInsightsPage />, index: true },
          { path: 'insights', element: <DeliveryInsightsPage /> },
          { path: 'driver', element: <DeliveryPersonPage /> },
          { path: 'returns', element: <ReturnsPage /> },
          { path: 'returns_refund', element: <ReturnsRefundPage /> },
          { path: 'zones', element: <ZonesPage /> },
          { path: 'cities', element: <CitiesPage /> },
          { path: 'utilities', element: <UtilitiesPage /> }
        ],
      },
      {
        path: 'configuration',
        children: [
          { element: <BannerConfigPage />, index: true },
          { path: 'banner', element: <BannerConfigPage /> },
          { path: 'featured', element: <FeaturedProductConfigPage /> }
        ],
      },
      {
        path: 'profile',
        children: [
          { element: <PageProfileSecurity />, index: true },
          { path: 'security', element: <PageProfileSecurity /> }
        ],
      }
    ]
  }
];